import { supabase } from "../../Services/supabaseClient";

const buildRoute = (row) => {
  if (row.record_type === "lead") {
    return "/crm/leads";
  }

  if (row.record_type === "account") {
    return `/crm/accounts/${row.record_id}`;
  }

  if (row.record_type === "contact") {
    return "/crm/contacts";
  }

  if (row.record_type === "opportunity") {
    return `/crm/opportunities/${row.record_id}`;
  }

  if (row.record_type === "quote") {
    return `/crm/quotes/${row.record_id}`;
  }

  return "/crm";
};

export const searchCrmRecords = async (companyId, searchTerm) => {
  const cleanTerm = String(searchTerm || "").trim();

  if (!cleanTerm) {
    return [];
  }

  const { data, error } = await supabase
    .from("crm_global_search_view")
    .select("*")
    .eq("company_id", companyId)
    .or(`title.ilike.%${cleanTerm}%,subtitle.ilike.%${cleanTerm}%`)
    .order("created_at", { ascending: false })
    .limit(20);

  if (error) {
    throw error;
  }

  return (data || []).map((row) => ({
    ...row,
    route: buildRoute(row),
  }));
};
